export const getBusinessPhoneNumbersUrl = () => 'business/phone_numbers';
export const getHostSmsUrl = () => 'business/host_sms';
export const getHostSmsVerifyUrl = (id: number | string) => `business/host_sms/${id}/verify`;
export const getHostSmsResendOtpUrl = (id: number | string) => `business/host_sms/${id}/resend_otp`;
export const getHostSmsCheckImportabilityUrl = () => 'business/host_sms/check_importability';
export const getHostSmsCreateImportOrderUrl = (id: number | string) => `business/host_sms/${id}/create_import_order`;
export const getHostSmsDetailUrl = (id: number | string) => `business/host_sms/${id}`;
export const getA2pBrandsUrl = () => 'business/a2p_brands';
export const getA2pBrandDetailUrl = (id: number | string) => `business/a2p_brands/${id}`;
export const getA2pCampaignsUrl = () => 'business/a2p_campaigns';
export const getA2pCampaignPricingUrl = () => 'business/a2p_campaigns/pricing';
export const getA2pCampaignDetailUrl = (id: number | string) => `business/a2p_campaigns/${id}`;
export const getA2pCampaignLinkNumbersUrl = (id: number | string) => `business/a2p_campaigns/${id}/link_numbers`;
export const getA2pCampaignLinkableNumbersUrl = (id: number | string) =>
  `business/a2p_campaigns/${id}/linkable_numbers`;
